import type {
  EventsOverviewProduct,
  Product,
  ProductPreference,
} from "mws-ts-v2-sdk";

type ProductTypes =
  | Product
  | EventsOverviewProduct
  | (ProductPreference & { isFollowedByUser?: boolean });

const isEventOverviewProduct = (
  product: ProductTypes,
): product is EventsOverviewProduct => {
  return !("prices" in product);
};

export default isEventOverviewProduct;
